<template>
<footer>
    <p>CopyRight 2020  广东南方周末经营有限公司</p>
    <p>版本<span>v{{version}}</span><span> | </span>构建版本：<span>{{buildAt}}</span></p>
</footer>
</template>
<script>
import config from "@/configs/"
export default {
    data(){
        return {
            version: config.version,
            buildAt: config.buildAt
        }
    }
}
</script>
